import React, { useEffect } from "react";
import Navbar from "../../components/main/Navbar";
import SearchHeader from "../../components/main/SearchHeader";
import { DeviceLogUsecontext } from "../../context/AdminDashboard/DeviceLogContext";
import Log from "../../components/adminPage/Log";
import Pagination from "../../components/main/Pagination";
import Loading from "../../components/atoms/Loading";

const DeviceLog = () => {
  const {
    DeviceLog,
    onLog,
    BtnlogSearch,
    logtext,
    loaded,
    countallPge,
    pagenumber,
    changePage,
    serialnumber,
    goBack,
  } = DeviceLogUsecontext();

  const urlParams = new URLSearchParams(window.location.search);

  useEffect(() => {
    const id = urlParams.get("id");
    onLog(id);

    document.title = "تاریخچه فعالیت";
  }, []);

  return (

    <div className="h-100">
      <Navbar titles={["دستگاه‌ها", "فهرست دستگاه‌ها", "تاریخچه فعالیت"]} />
      <div
        className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px pb-7.5px mb-7.5px "
        dir="rtl">
        <SearchHeader
          title={"تاریخچه فعالیت "}
          buttnText="بازگشت"
          person={serialnumber}
          placeholder={"جست و جو: توضیحات فعالیت"}
          buttonSearch={BtnlogSearch}
          gettext={logtext}
          onClick={goBack}
          borderBlue="border-blue border-1"
        />
        {!loaded ? (
          <Loading height={"h-512"} />
        ) : (
          <>
            <Log
              loaded={loaded}
              dataLog={DeviceLog}
              emptyText="تاریخچه‌ای یافت نشد."
              Hempty="h-512"
            />
            <Pagination
              changePage={changePage}
              countAll={countallPge}
              currentPage={pagenumber}
            />
          </>
        )}
      </div>
    </div>
    
  );
};

export default DeviceLog;
